import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import LatestDramas from '@/pages/home/components/LatestDramas';
import HotNews from '@/pages/home/components/HotNews';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function Home() {
  useDocumentMeta({
    title: '善良的女秘书 - 影视剧剧情介绍与最新资讯',
    description:
      '善良的女秘书网站提供详尽的影视剧剧情介绍、角色分析及相关新闻更新，涵盖电视剧和电影等多种影视内容，帮助用户了解剧情发展与角色背景。',
    keywords:
      '善良的女秘书,影视剧,剧情介绍,角色分析,电视剧,电影,影视资讯',
  });

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryEntry />
      <LatestDramas />
      <HotNews />
      <SiteIntro />
    </div>
  );
}